export enum SalesOrderPaymentType {
  Cash = 'cash',
  BankTransfer = 'bank_transfer',
}
